import { t } from 'i18next';
import { useFormContext } from 'react-hook-form';

import { ControlledSelect } from 'components/shared';
import { getMethodOptions } from './MethodSelectSection.utils';

export default function MethodSelectSection() {
  const { control } = useFormContext();

  return (
    <ControlledSelect
      control={control}
      name="method"
      variant="outlined"
      label={t('surchargesMaintenance.form.method')}
      options={getMethodOptions(t)}
    />
  );
}
